import { FormGroup, FormBuilder } from "@angular/forms";

export class M_STORE_HOLIDAY {
    no: number = 0;

    hQ_CD: string = '';
    stR_CD: string = '';

    holidaY_SEQ: number = 0;
    holidaY_TP: string = '';
    holidaY_TP_NM: string = '';

    day: string | null = null;
    daY_NM: string | null = null;

    year: string = '';
    month: string = '';
    date: string = '';

    holidaY_YN: string = 'N';
    remark: string | null = null;
    usE_YN: string = 'Y';
    isUse : boolean = false;

    inserT_DT: Date | null = null;
    inserT_USER: string | null = null;
    updatE_DT: Date | null = null;
    updatE_USER: string | null = null;

    newFG: boolean = false;

    constructor(init?: Partial<M_STORE_HOLIDAY>) {
        Object.assign(this, init);
    }

    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];
            obj[key] = value ?? null;
        });

        return obj;
    }

    fromJSON(json: any): M_STORE_HOLIDAY {
        return new M_STORE_HOLIDAY({
            ...json,
            inserT_DT: this.parseISODate(json?.inserT_DT),
            updatE_DT: this.parseISODate(json?.updatE_DT)
        });
    }

    getAll(res: any[]): M_STORE_HOLIDAY[] {
        return (res ?? []).map(e => this.fromJSON(e));
    }

    createForm(fb: FormBuilder): FormGroup {
        return fb.group({
            hQ_CD: [''],
            stR_CD: [''],
            holidaY_SEQ: [0],
            holidaY_TP: [''],
            holidaY_TP_NM: [''],
            day: [null],
            daY_NM: [null],
            year: [''],
            month: [''],
            date: [''],
            holidaY_YN: ['N'],
            remark: [null],
            usE_YN: ['Y']
        });
    }

    parseISODate(value: string): Date | null {
        if (!value) return null;
        return new Date(value);
    }

    /** yyyy-MM-dd */
    formatToDateString(): string {
        if (!this.year || !this.month || !this.date) return '';
        return `${this.year}-${this.month.padStart(2,'0')}-${this.date.padStart(2,'0')}`;
    }

    /** yyyyMMdd */
    formatToCompactDate(): string {
        if (!this.year || !this.month || !this.date) return '';
        return `${this.year}${this.month.padStart(2,'0')}${this.date.padStart(2,'0')}`;
    }

    /** convert Date -> year/month/date */
    setFromDate(dateObj: Date | null) {
        if (!dateObj) return;

        this.year = String(dateObj.getFullYear());
        this.month = String(dateObj.getMonth() + 1).padStart(2, '0');
        this.date = String(dateObj.getDate()).padStart(2, '0');
    }

    /** convert year/month/date -> Date */
    toDate(): Date | null {
        if (!this.year || !this.month || !this.date) return null;
        return new Date(
            Number(this.year),
            Number(this.month) - 1,
            Number(this.date)
        );
    }
}